// Unit Proficiency — milestone multipliers (AdVenture Capitalist staple).
// Owning enough copies of a tier permanently sharpens it: each threshold reached
// doubles that tier's output. Pure function of the owned count, so it derives
// cleanly on the server too.
export const PROFICIENCY_MILESTONES = [10, 25, 50, 100, 150, 200, 300, 400, 500, 750, 1000];

export function proficiencyLevel(count) {
  let level = 0;
  for (const threshold of PROFICIENCY_MILESTONES) {
    if (count >= threshold) level += 1; else break;
  }
  return level;
}

export function proficiencyMultiplier(count) {
  return 2 ** proficiencyLevel(count);
}

export function nextProficiency(count) {
  for (const threshold of PROFICIENCY_MILESTONES) {
    if (count < threshold) return threshold;
  }
  return null;
}
